var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "novel-list-toolbar" }, [
    _c("div", { staticClass: "toolbar-pc pc" }, [
      _c("div", { staticClass: "toolbar-left" }, [
        _c(
          "div",
          {
            staticClass: "search-input-wrapper",
            class: { "search-active": _vm.searchQuery },
          },
          [
            _c("IconSearch", { staticClass: "search-icon" }),
            _c("input", {
              staticClass: "search-input",
              attrs: {
                type: "text",
                placeholder: _vm.$t(
                  "homePage.novelList.toolbar.searchPlaceholder"
                ),
              },
              domProps: { value: _vm.searchQuery },
              on: { input: _vm.onSearchInput },
            }),
          ],
          1
        ),
        _c(
          "button",
          {
            staticClass: "toolbar-icon-button",
            class: { active: _vm.hasActiveFilter },
            on: {
              click: function ($event) {
                return _vm.$emit("open-filter")
              },
            },
          },
          [_c("IconSlider", { staticClass: "toolbar-icon-svg" })],
          1
        ),
      ]),
      _c("div", { staticClass: "toolbar-right" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.closeSortDropdown,
                expression: "closeSortDropdown",
              },
            ],
            staticClass: "sort-dropdown-wrapper",
          },
          [
            _c(
              "button",
              {
                staticClass: "sort-dropdown-trigger",
                on: { click: _vm.toggleSortDropdown },
              },
              [
                _c("IconMenu", { staticClass: "sort-prefix-icon" }),
                _c("span", { staticClass: "sort-label" }, [
                  _vm._v(_vm._s(_vm.currentSortLabel)),
                ]),
                _c("IconChevronDown", { staticClass: "sort-chevron" }),
              ],
              1
            ),
            _vm.isSortDropdownOpen
              ? _c(
                  "div",
                  { staticClass: "sort-dropdown-menu" },
                  _vm._l(_vm.sortOptions, function (option) {
                    return _c(
                      "button",
                      {
                        key: option.value,
                        staticClass: "sort-dropdown-item",
                        class: { active: _vm.sortKey === option.value },
                        on: {
                          click: function ($event) {
                            return _vm.onSelectSort(option.value)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(option.label) + " ")]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "toolbar-icon-button",
            attrs: { disabled: !_vm.sortKey },
            on: { click: _vm.onToggleSortOrder },
          },
          [
            _vm.sortOrder === "asc"
              ? _c("IconOrderAsc", { staticClass: "toolbar-icon-svg" })
              : _c("IconOrderDesc", { staticClass: "toolbar-icon-svg" }),
          ],
          1
        ),
        _c(
          "button",
          {
            staticClass: "toolbar-icon-button",
            on: {
              click: function ($event) {
                return _vm.$emit(
                  "update:layout",
                  _vm.layout === "grid" ? "list" : "grid"
                )
              },
            },
          },
          [
            _vm.layout === "grid"
              ? _c("IconLayoutList", { staticClass: "toolbar-icon-svg" })
              : _c("IconLayoutGrid", { staticClass: "toolbar-icon-svg" }),
          ],
          1
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "toolbar-sp sp" },
      [
        _vm.isSpSearchOpen
          ? _c("div", { staticClass: "sp-search-bar" }, [
              _c(
                "div",
                {
                  staticClass: "search-input-wrapper",
                  class: { "search-active": _vm.searchQuery },
                },
                [
                  _c("IconSearch", { staticClass: "search-icon" }),
                  _c("input", {
                    ref: "spSearchInput",
                    staticClass: "search-input",
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t(
                        "homePage.novelList.toolbar.searchPlaceholder"
                      ),
                    },
                    domProps: { value: _vm.searchQuery },
                    on: { input: _vm.onSearchInput, blur: _vm.onSpSearchBlur },
                  }),
                  _c("button", {
                    staticClass: "sp-search-close",
                    on: {
                      mousedown: function ($event) {
                        $event.preventDefault()
                      },
                      click: _vm.onSpSearchClose,
                    },
                  }),
                ],
                1
              ),
            ])
          : [
              _c("div", { staticClass: "toolbar-left" }, [
                _c(
                  "button",
                  {
                    staticClass: "toolbar-icon-button",
                    class: { active: _vm.searchQuery },
                    on: { click: _vm.toggleSpSearch },
                  },
                  [_c("IconSearch", { staticClass: "toolbar-icon-svg" })],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "toolbar-icon-button",
                    class: { active: _vm.hasActiveFilter },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("open-filter")
                      },
                    },
                  },
                  [_c("IconSlider", { staticClass: "toolbar-icon-svg" })],
                  1
                ),
              ]),
              _c("div", { staticClass: "toolbar-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "toolbar-icon-button",
                    class: { active: _vm.sortKey },
                    on: { click: _vm.toggleSpSort },
                  },
                  [_c("IconMenu", { staticClass: "toolbar-icon-svg" })],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "toolbar-icon-button",
                    on: {
                      click: function ($event) {
                        return _vm.$emit(
                          "update:layout",
                          _vm.layout === "grid" ? "list" : "grid"
                        )
                      },
                    },
                  },
                  [
                    _vm.layout === "grid"
                      ? _c("IconLayoutList", {
                          staticClass: "toolbar-icon-svg",
                        })
                      : _c("IconLayoutGrid", {
                          staticClass: "toolbar-icon-svg",
                        }),
                  ],
                  1
                ),
              ]),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }